<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/img/toplogo.png" alt />
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router">
          <el-menu-item index="/">{{$t('navigateBar.homePage')}}</el-menu-item>
<!--          <el-menu-item index="/news">{{$t('navigateBar.newsInformation')}}</el-menu-item>-->
          <el-menu-item index="/product">{{$t('navigateBar.productCenter')}}</el-menu-item>
          <el-menu-item index="/goin">{{$t('navigateBar.aboutUs')}}</el-menu-item>
        </el-menu>
        <el-button type="text"><ChangeLanguage /></el-button>
        <el-button type="text">{{$t('signIn')}}</el-button>
      </el-header>

      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>{{$t('footer.aboutUs')}}</p>
<!--              <span>{{$t('footer.child.developmentHistory')}}</span>-->
<!--              <span>{{$t('footer.child.corporateCulture')}}</span>-->
              <span>{{$t('footer.child.qualificationAndHonor')}}</span>
<!--              <span>{{$t('footer.child.cooperativePartner')}}</span>-->
            </li>
<!--            <li>-->
<!--              <p>{{$t('footer.newsInformation')}}</p>-->
<!--              <span>{{$t('footer.child.companyNews')}}</span>-->
<!--              <span>{{$t('footer.child.industryNews')}}</span>-->
<!--            </li>-->
            <li>
              <p>{{$t('footer.productCenter')}}</p>
              <span>{{$t('footer.child.productIntroduction')}}</span>
            </li>
            <li>
              <p>{{$t('footer.contactUs')}}</p>
              <span>{{$t('footer.child.email')}}</span>
<!--              <span>{{$t('footer.child.phone')}}</span>-->
              <span>{{$t('footer.child.address')}}</span>
            </li>
          </ul>
<!--          <img src="./assets/img/ercode.png" alt />-->
          <div></div>
        </div>
        <div class="copyright">
<!--          <span>毅达版权所有</span>-->
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import ChangeLanguage from '@/i18n/change-language'

export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false
    };
  },
  components: {
    ChangeLanguage,
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 77.5rem; //  1240px
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 17.5rem; // 280px;
    //padding: 10px;
    img {
      width: 100%;
      line-height: 3.75rem; // 60px;
      height: 3.75rem; // 60px;
    }
  }
}

.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 13.5rem; // 216px;
  overflow: hidden;
  background-color: #18191A;
  &-content {
    width: 77.5rem; //  1240px
    margin: 0 auto;
    padding-top: 1.25rem; // 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 1.25rem; // 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 1.25rem; // 20px;
          color: #d4edff;
          padding: 0.625rem 0; // 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 10.625rem; // 170px;
      height: 10.625rem; // 170px;
      padding: 0.625rem; // 10px;
    }
  }
  .copyright {
    height: 1.875rem; // 30px;
    background: #18191A;
    span {
      color: #fff;
      line-height: 1.875rem; // 30px;
    }
  }
}

@media (max-width: 500px) {
  .el-header {
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;
    margin: 0 auto;

    .logo {
      width: 1%; // 17.5rem; // 280px;
      //padding: 10px;
      img {
        width: 100%;
        line-height: 3.75rem; // 60px;
        height: 3.75rem; // 60px;
      }
    }
  }

  .footer {
    width: 100%;
    height: 13.5rem;
    overflow: hidden;
    background-color: #18191A;
    &-content {
      width: 100%;
      margin: 0 auto;
      padding-top: 1.25rem; // 20px;
      display: flex;
      justify-content: space-between;
      .content-nav {
        display: flex;
        justify-content: space-around;
        li {
          display: flex;
          flex-direction: column;
          padding: 0 1.25rem; // 20px;
          //justify-content: center;
          align-items: flex-start;
          p {
            font-size: 1.25rem; // 20px;
            color: #d4edff;
            padding: 0.625rem 0; // 10px 0;
          }
          span {
            color: #f7f7f7;
            font-weight: 300;
            padding: 5px 0;
          }
        }
      }
      img {
        width: 10.625rem; // 170px;
        height: 10.625rem; // 170px;
        padding: 0.625rem; // 10px;
      }
    }
    .copyright {
      height: 1.875rem; // 30px;
      background: #18191A;
      span {
        color: #fff;
        line-height: 1.875rem; // 30px;
      }
    }
  }
}



</style>
